import { Outlet } from "react-router";

import { usePrivacy } from "../lib/privacy";
import { DraftsProvider } from "../pages/day/drafts";
import { Header } from "./Header";
import { NewVersionBanner } from "./NewVersionBanner";
import { OwnerToolsKey } from "./OwnerToolsKey";
import { RenewalBanner } from "./RenewalBanner";
import { useSession } from "./session-context";
import { usePrivacyReload } from "./usePrivacyReload";

/** The page frame: 16px outer margin, panels 12px apart (section 11.0). The main area fills the window. */
export function Layout() {
  const { auth } = useSession();
  const privacy = usePrivacy();
  usePrivacyReload(privacy);
  return (
    <div className="flex min-h-screen flex-col gap-3 bg-page p-4">
      {/* The backtick key opens Owner tools, for owners only (ADR 0098), and
          so does the header's user menu. */}
      <OwnerToolsKey>
        <Header />
      </OwnerToolsKey>
      {/* A sign-in to renew never takes the page away (#252; ADR 0093). */}
      <RenewalBanner auth={auth} />
      {/* A newer release than this tab runs (#290; ADR 0117). */}
      <NewVersionBanner />
      {/* Drafts in the Log form live for the session, across pages and days,
          and are saved on their blocks (ADR 0097). Privacy mode starts them
          afresh: typing never crosses from the real data to a demo, or back
          (ADR 0145). */}
      <DraftsProvider key={privacy ? "demo" : "live"}>
        <main className="flex flex-1 flex-col gap-3">
          <Outlet />
        </main>
      </DraftsProvider>
    </div>
  );
}
